<ng-template #template1>
    <div class="border-0 rounded-0 pb-0">
      <div class="welcome-header">
        <h4 class="modal-title pull-left"></h4>
        <button type="button" class="close hide close-abs pull-right text-right" id="editclose" name="editclose" aria-label="Close" (click)="modalRef.hide();">
          <span aria-hidden="true"></span>
        </button>
      </div>
    </div>
    <div class="modal-body">
      <div class="p-2">
        <h3>Welcome to MOM</h3>
        <p class="text-secondary">Mom is secure Login for all your MOM applications. Use your DEWA credentials to access your applications seamlessly. All in one place and from any device!</p>
        <p class="text-secondary">
          Any Questions?
          drop an email at <a href="mailto:mom@dewa.gov.ae" class="pointer" target="_blank">mom@dewa.gov.ae</a>
        </p>
        <div class="text-center py-3">
          <button class="btn btn-success btn-sm" (click)="modalRef.hide();" >OK</button>
        </div>
      </div>
    </div>
  </ng-template>
  
  
  <style>
    .login-screen app-header {
      display: none !important;
    }
  </style>
  
  <div class="container-fluid border-bottom py-3 bg-white">
    <div class="row">
      <div class="col"><a routerLink=""><img class="img-fluid" src="\assets\v2\img\dubai-gov-logo.png" style="max-height: 70px;width: auto;" alt="" /></a></div>
      <div class="col text-center"><img class="img-fluid" src="\assets\v2\img\emirates-logo.png" alt="" /></div>
      <div class="col text-right"><img class="img-fluid" src="\assets\v2\img\dewa-logo.png" alt="" /></div>
    </div>
  </div>
  <div class="container-fluid bg-white" id="loginScreen">
    <div class="row">
      <div class="col-lg-8 mt-4">
        <div class="p-4 mt-4 welcone-txt">
          <h3 class="pt-4 mb-0 mt-md-4">Welcome to</h3>
          <h2 class="font-weight-bold">Minutes of Meeting (MOM)</h2>
          <p class="text-secondary pt-4">Use Minutes of Meeting (MOM) platform to record, document minutes of meeting digitally and share it  easily by email.</p>
  
        </div>
      </div>
      <div class="col-lg-4 offset-md-2 p-0 border-left login-bg hgt-login h-100vh">
        <div class="px-2 py-4 bg-white login-box rounded">
          <div class="mx-4 custom-tab position-relative">
            <h5 class="f-bold-dubai py-2"> Login </h5>
            <!--<span class="information"><a (click)="openModalnewMeeting(template1);"><i class="text-secondary fa fa-info rounded-circle"></i></a></span>-->
            <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
              <div class="form-group">
                <label for="username">Username</label>
                <input type="text" formControlName="username" class="form-control" placeholder="Username" [ngClass]="{ 'is-invalid': submitted && f.username.errors }" />
                <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
                  <div *ngIf="f.username.errors.required">Username is required</div>
                </div>
              </div>
              <div class="form-group">
                <label for="password">Password</label>
                <input type="password" formControlName="password" placeholder="Password" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
  
                <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                  <div *ngIf="f.password.errors.required">Password is required</div>
                </div>
              </div>
  
              <div class="form-group">
  
                <div class="col-lg-12 px-0 py-2" *ngIf="!loading">
                  <button class="btn btn-success btn-sm py-2 pl-4 pr-4 btn-block" name="action" type="submit"> Login </button>
                </div>
                <div class="col-lg-12 px-0 py-0 text-right" *ngIf="isforgot">
                  <small><a (click)="openForgotPasswordModal(forgotPassword)" class="text-info">Forgot Password</a></small>
                </div>
                <div class="col-lg-12 px-0 py-2" *ngIf="loading">
                  <button class="btn btn-success btn-sm px-4 py-2 btn-block" name="action"> Please wait  <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span> </button>
                </div>
              </div>
  
            </form>
  
  
          </div>
        </div>
  
      </div>
    </div>
  </div>
  
  
  <ng-template #forgotPassword>
    <div class="modal-header">
      <h4 class="modal-title pull-left f-bold-dubai">Forgot Password</h4>
  
      <button type="button" class="close pull-right" aria-label="Close" (click)="modalFPassword.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <p>
        If the e-mail you have entered exists in our system, we will send a password in a second<br />
      </p>
  
    </div>
    <div class="modal-footer border-0">
      <button type="button" class="btn btn-outline-secondary" (click)="modalFPassword.hide()">Cancel</button>
      <button type="button" class="btn btn-success" (click)="forgotPassWord()">Request</button>
    </div>
  </ng-template>
  